import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import EditorLoader from './EditorLoader';
import type { ImageEditorProps } from './types';

const DynamicEditor = dynamic(() => import('./Editor'), {
  ssr: false,
});

const EditorSuspended: React.FC<React.PropsWithChildren<ImageEditorProps>> = (p) => {
  return (
    <Suspense fallback={<EditorLoader disableBgEdit={p.disableBgEdit} />}>
      <DynamicEditor {...p} />
    </Suspense>
  );
};

export default EditorSuspended;
